import { balanceValuesActions } from '../../store/balanceValues';

// Standalone utility functions that don't depend on table instance
export const getPercentPaid = (_columnId, leafRows) => {
  let totalPaid = 0;
  leafRows.map((row) => {
    row.original.statusPayment && totalPaid++;
  });
  const total = leafRows.length;
  return `${totalPaid}/${total} Pago`;
};

export const getCheckedRows = (rows, columnIds, filterValue) => {
  if (filterValue === 'checked') {
    return rows.getIsSelected() && rows.original;
  }

  if (filterValue === 'unchecked') {
    return !rows.getIsSelected() && rows.original;
  }
};

export const createTableUtils = (dispatch, table) => {
  // Calculate balance values without dispatching (pure calculation)
  const calculateBalanceValues = (tableObj) => {
    if (!tableObj) {
      return { input: 0, output: 0, transferIn: 0, transferOut: 0 };
    }

    let input = 0;
    let output = 0;
    let transferIn = 0;
    let transferOut = 0;

    let rowsToProcess;

    try {
      // Safely try to access select column and determine which rows to process
      const selectColumn = table?.getColumn('select');
      const selectFilterValue = selectColumn?.getFilterValue();

      if (selectFilterValue === 'unchecked') {
        rowsToProcess = tableObj.getFilteredRowModel()?.flatRows || [];
      } else if (tableObj.getFilteredSelectedRowModel()?.flatRows?.length > 0) {
        rowsToProcess = tableObj.getFilteredSelectedRowModel().flatRows;
      } else {
        rowsToProcess = tableObj.getFilteredRowModel()?.flatRows || [];
      }
    } catch (error) {
      // Fallback: if there's any issue with select column, process all filtered rows
      console.warn('Error accessing select column for balance calculation, using all rows:', error);
      rowsToProcess = tableObj.getFilteredRowModel()?.flatRows || [];
    }

    // Ensure rowsToProcess is an array
    if (!Array.isArray(rowsToProcess)) {
      rowsToProcess = [];
    }

    rowsToProcess.forEach((item) => {
      if (!item?.original) return;

      if (item.original.isInput === true) {
        if (item.original.journalEntryType === 5) {
          transferIn += Math.abs(item.original.value || 0);
        } else {
          input += Math.abs(item.original.valueFinal || 0);
        }
      } else if (item.original.isInput === false) {
        if (item.original.journalEntryType === 5) {
          transferOut += Math.abs(item.original.value || 0);
        } else {
          output += Math.abs(item.original.valueFinal || 0);
        }
      }
    });

    return { input, output, transferIn, transferOut };
  };

  // Dispatch balance updates (should be called from useEffect, not render)
  const updateBalanceValues = (tableObj) => {
    if (!tableObj) return;

    const { input, output, transferIn, transferOut } = calculateBalanceValues(tableObj);

    dispatch(balanceValuesActions.resetValues());
    dispatch(balanceValuesActions.setInput(input));
    dispatch(balanceValuesActions.setOutput(output));
    dispatch(balanceValuesActions.setTransferInput(transferIn));
    dispatch(balanceValuesActions.setTransferOutput(transferOut));
  };

  const selectRowHandler = (e, row) => {
    row.toggleSelected(e.target.checked);

    const selectColumn = table.getColumn('select');
    const selectedFilter = selectColumn.getFilterValue();
    selectedFilter !== undefined && selectColumn.setFilterValue(selectedFilter);
  };

  const selectAllHandler = (e, table) => {
    table.toggleAllRowsSelected(e.target.checked);
    const selectColumn = table.getColumn('select');
    const selectedFilter = selectColumn.getFilterValue();
    selectedFilter !== undefined && selectColumn.setFilterValue(selectedFilter);
  };

  const getPercentPaid = (_columnId, leafRows) => {
    let totalPaid = 0;
    leafRows.map((row) => {
      row.original.statusPayment && totalPaid++;
    });
    const total = leafRows.length;
    return `${totalPaid}/${total} Pago`;
  };

  const getCheckedRows = (rows, columnIds, filterValue) => {
    if (filterValue === 'checked') {
      return rows.getIsSelected() && rows.original;
    }

    if (filterValue === 'unchecked') {
      return !rows.getIsSelected() && rows.original;
    }
  };

  return {
    updateBalanceValues,
    selectRowHandler,
    selectAllHandler,
  };
};
